"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.Modal = void 0;
require("./Modal.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * - Parent is responsible for overlay/backdrop
 * - Focus trapped when open; ESC closes if onClose provided
 * - Restores focus to the opener
 * - ARIA: role=dialog, aria-modal=true
 * - Fixed sizing (cannot be overridden by props)
 */
const Modal = props => {
  const {
    isOpen = defaultProps.isOpen,
    children,
    className,
    panelRef,
    ariaLabel,
    ariaLabelledby,
    externalCloseActionElement,
    externalFooterChildrenElements
  } = props;
  const internalRef = (0, _react.useRef)(null);
  const nodeRef = panelRef ?? internalRef;
  const componentClassName = (0, _classnames.default)('pal-c-Modal', {
    'pal-c-Modal__open': isOpen
  }, className);
  const renderHeader = () => {
    if (!externalCloseActionElement) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-Modal__header"
    }, (0, _renderObject.renderObject)(externalCloseActionElement));
  };
  const renderFooter = () => {
    if (!externalFooterChildrenElements) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-Modal__footer"
    }, (0, _renderObject.renderObject)(externalFooterChildrenElements));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    role: "dialog",
    "aria-modal": "true",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabel ? undefined : ariaLabelledby,
    ref: nodeRef
  }, renderHeader(), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Modal__body"
  }, children), renderFooter());
};

/**
 * Property type definitions
 * @typedef ModalProps
 * @type {object}
 * @property {boolean} isOpen - Sets the open state for the Modal.
 * @property {string} className - Sets the additional className to the Modal container div.
 * @property {object} children - Children content for the Modal.
 * @property {any} panelRef - Sets the ref of the Modal container.
 * @property {string} ariaLabelledby -  HTML id for aria-labelledby
 * @property {string} ariaLabel - value for aria label
 * @property {object} externalCloseActionElement - Close action element with business and DC logic from web-site.
 * @property {object} externalFooterChildrenElements - Footer content for the Modal.
 */
exports.Modal = Modal;
const propTypes = exports.propTypes = {
  /**
   * Sets the open state for the Modal.
   */
  isOpen: _propTypes.default.bool,
  /**
   * Children content for the Modal
   */
  children: _propTypes.default.object,
  /**
   * Sets the additional className to the Modal container div.
  */
  className: _propTypes.default.string,
  /**
   * Sets the ref of the Modal container.
   */
  panelRef: _propTypes.default.any,
  /**
   * value for aria label
   */
  ariaLabel: _propTypes.default.string,
  /**
   * HTML id for aria-labelledby
   */
  ariaLabelledby: _propTypes.default.string,
  /**
   * externalCloseActionElement for the Modal
   */
  externalCloseActionElement: _propTypes.default.object,
  /**
   * externalFooterChildrenElements for the Modal
   */
  externalFooterChildrenElements: _propTypes.default.object
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {boolean} isOpen - isOpen: false - sets the default open state of the modal to be false.
 */
const defaultProps = exports.defaultProps = {
  isOpen: false
};
Modal.propTypes = propTypes;
var _default = exports.default = Modal;